export const BaseFillGift = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M2 7.75C2 7.19772 2.44772 6.75 3 6.75H21C21.5523 6.75 22 7.19772 22 7.75V9.25C22 9.80228 21.5523 10.25 21 10.25H3C2.44772 10.25 2 9.80228 2 9.25V7.75Z"
      fill="currentColor"
    />
    <path
      d="M6 5C6 3.61929 7.11929 2.5 8.5 2.5H9C10.6569 2.5 12 3.84315 12 5.5V7.5H8.5C7.11929 7.5 6 6.38071 6 5V5Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M18 5C18 3.61929 16.8807 2.5 15.5 2.5H15C13.3431 2.5 12 3.84315 12 5.5V7.5H15.5C16.8807 7.5 18 6.38071 18 5V5Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path d="M12.75 11.75H21V19.75C21 20.8546 20.1046 21.75 19 21.75H12.75V11.75Z" fill="currentColor" />
    <path d="M3 11.75H11.25V21.75H5C3.89543 21.75 3 20.8546 3 19.75V11.75Z" fill="currentColor" />
  </svg>
);
